export function footerFailed() {
    document.getElementById("footer-container").innerHTML = "";
}

export function lazyLoadFooter() {
    let footer = document.getElementById("footer-container");
    fetch('/_embeds/footer')
    .then(response => {
        footer.classList.add('sidebar-fade-out');
        return response.text();
    })
    .then (html => {
        footer.innerHTML = html;
        footer.classList.remove('sidebar-fade-out');
        setupFooterDropdowns();
        return true;
    })
}

export function setupFooterDropdowns() {
    //Setup footer accordion triggers
    let accordianTriggers = document.querySelectorAll('.acc-toggle');

    for (let x = 0; x < accordianTriggers.length; x++)
    {
        // wf-seo-opt-2026 new code start
        // this prevents duplicate listeners when footer setup is called multiple times
        if (accordianTriggers[x].dataset.wfSeoOptBound === "1") {
            continue;
        }
        accordianTriggers[x].dataset.wfSeoOptBound = "1";
        // wf-seo-opt-2026 new code end

        /* wf-seo-opt-2026 old code start
        accordianTriggers[x].addEventListener('click', function(event) {
        wf-seo-opt-2026 old code end */
        accordianTriggers[x].addEventListener('click', function(event) {
            event.target.parentNode.parentNode.classList.toggle('closed');
            event.target.querySelector('.accordian-arrow').classList.toggle('rotate');
            dataLayer.push(
                {
                    'event': 'myTrackEvent', 
                    'eventCategory': 'Footer', 
                    'eventAction': 'Toggle', 
                    'eventLabel': 'Footer accordion'
                }
            );
        })
    }
}

export function checkCatfishLocation() {
    var elements = document.getElementsByClassName('form_location');

    //Catfish isn't loaded on this page, ignore
    if (elements.length == 0 || !elements) {
        return;
    }

    //Parse current URL and check if we're on the directory or single entry
    var currentAddress = window.location;
    var path = currentAddress.pathname;

    var location = "";

    if (path.indexOf('directory') != -1) {
        location = "Directory"
    } else if (path.indexOf("-franchises/") != -1) {
        location = "Single Entry Popup"
    } else {
        location = "Catfish";
    }

    for (var x = 0; x < elements.length; x++) {
        elements[x].value = location
    }
}

export function ajaxRequest (urlStr, paramsObj, successCallback, failCallback) {
    successCallback = successCallback || undefined;
    failCallback = failCallback || undefined;
    // Build query string
    var queryStringArr = [];
    var objectKeys = Object.keys(paramsObj);
    for (var i=0; i < objectKeys.length; i++)
    {
        var key = objectKeys[i];
        var valToPush = "";
        if (Array.isArray(paramsObj[key]))
        {
            var array = paramsObj[key];
            for (var x = 0; x < array.length; x++)
            {
                valToPush = key+'='+array[x];
                queryStringArr.push(valToPush);
            }
        } else {
            valToPush = key+"="+paramsObj[key];
            queryStringArr.push(valToPush);
        }
    }
        

    var queryStr = queryStringArr.join("&");

    // HTTP request, open urlStr and send queryStr as post data
    var http = new XMLHttpRequest();
    http.open('POST', urlStr, true);
    http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    http.send(queryStr);

    // On ready state change
    http.onreadystatechange = function() {
        // Valid response from server
        if(http.readyState == 4 && http.status == 200) {
            if (successCallback) {
                successCallback(http.responseText);
            }
        // Response returned but an error occured
        } else if (http.readyState == 4 && http.status != 200){
            if (failCallback) {
                failCallback(http.status);
            }
        }
    }
}

export function checkWidth() {
    var elements = document.getElementsByClassName('device_width');
    if (elements.length == 0 || !elements) {
        return;
    } 
    var deviceWidth = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;
        

    for (var x = 0; x < elements.length; x++) {
        elements[x].value = deviceWidth
    }
}

//Create an on the fly post request to a URL with supplied parameters
export function post(path, params) {
    var form = document.createElement('form');
    form.method = 'post';
    form.action = path;
  
    for (var key in params) {
      if (params.hasOwnProperty(key)) {
          if (Array.isArray(params[key]))
          {
              var array = params[key];
              for (var x = 0; x < array.length; x++)
              {
                var hiddenField = document.createElement('input');
                hiddenField.type = 'hidden';
                hiddenField.name = key;
                hiddenField.value = array[x];
          
                form.appendChild(hiddenField);
              }
          } else {
            var hiddenField = document.createElement('input');
            hiddenField.type = 'hidden';
            hiddenField.name = key;
            hiddenField.value = params[key];
      
            form.appendChild(hiddenField);
          }
      }
    }
  
    document.body.appendChild(form);
    form.submit();
  }

  export function createEnquiryPurchases(enquiryObj, location) {
    let purchases = [];
    for (let x = 0; x < enquiryObj.companies.length; x++) {
        purchases.push({
            'sku': enquiryObj.companies[x].id,
            'name': enquiryObj.companies[x].name,
            'category': enquiryObj.companies[x].category,
            'price': 1,
            'quantity': 1
        })
    }

    dataLayer.push({
        'event': 'transactionEvent',
        'transactionId': Math.floor(Math.random() * 1000000000),
        'transactionAffiliation': location,
        'transactionTotal': 1 * enquiryObj.companies.length,
        'transactionTax': 0,
        'transactionShipping': 0,
        'transactionProducts': purchases
    });

}

export function smoothScroll(element, event) {
    event.preventDefault()
    document.querySelector(element.getAttribute('href')).scrollIntoView({
        behavior: 'smooth'
    });
}

export function newsletterSignUp(event) {
    event.preventDefault();
    document.querySelector('.newsletter-errors').classList.add('d-none');
    let formData = new FormData()
    let errors = [];

    let email =  event.target[0].value;
    if (email.length === 0) {
        return;
    }

    formData.append('email', email)
    formData.append('csrf_token', csrf_token)
    formData.append('campaign', 'newsletter')
    formData.append('url', window.location.pathname)

    fetch('/utilities/campaign-signup', {
        method: 'POST',
        body: formData
    })
    .then(response => response.json())
    .then(response => {
        if (response == 'success') {
            document.querySelector('#footerNewsletter h5').innerText = "Thanks for joining!";
            document.querySelector('#footerNewsletter p').innerText = "Please check your inbox to confirm your newsletter subscription with What Franchise."
            document.querySelector('#newsletter-email').classList.add('d-none');
            document.querySelector('#newsletter-subscribe-button').classList.add('d-none');
            dataLayer.push({
                'event': 'myTrackEvent',
                'eventCategory': 'Newsletter Signup',
                'eventAction': 'Footer',
                'eventLabel': window.location.pathname
            });
        } else {
            errors = response; 
            document.querySelector('.newsletter-errors').classList.remove('d-none');
            document.querySelector('.newsletter-errors').innerText = errors;
        }
    })
    .catch(error => {
        document.querySelector('.newsletter-errors').classList.remove('d-none');
        document.querySelector('.newsletter-errors').innerText = "Sorry, there was an error processing your request.";
    })
}

/**
 * Used to limit the rate at which a function can be called
 * e.g. on key up, but only x ms after they finish typing
 */
export const debounce = (func, wait) => {
    let timeout;
  
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
  
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };